import { Star } from 'lucide-react';
import toast from 'react-hot-toast';
import { favKey, useFavoriteStore } from '../../store/favoriteStore';
import type { ListEntityKind } from '../../types/list';

interface FavoriteStarProps {
  kind: ListEntityKind;
  id: string;
  size?: number;
  className?: string;
}

export function FavoriteStar({ kind, id, size = 18, className = '' }: FavoriteStarProps) {
  const isFav = useFavoriteStore((s) => s.keys.has(favKey(kind, id)));
  const toggle = useFavoriteStore((s) => s.toggle);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await toggle(kind, id);
    } catch {
      toast.error('Could not update favorite');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={isFav}
      aria-label={isFav ? 'Remove from favorites' : 'Add to favorites'}
      className={`p-1 rounded-lg transition-colors hover:bg-gray-100 dark:hover:bg-gray-800 ${className}`}
    >
      <Star
        width={size}
        height={size}
        strokeWidth={2}
        className={`transition-colors ${isFav ? 'text-amber-500' : 'text-gray-300 dark:text-gray-600'}`}
        fill={isFav ? '#f59e0b' : 'none'}
      />
    </button>
  );
}
